<!-- Reusa a tela de Clientes em modo embutido, sob contexto do cliente. -->
<app-clientes *ngIf="montado" [embutido]="true"></app-clientes>
